import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ButtonModule } from "@sitemule/ng-components/components/button";
import { SvgIconModule } from '@sitemule/ng-components/directives/svg-icon';
import { NgxTypedJsModule } from "ngx-typed-js";
import { LinksModule } from "../links/links.module";
import { StretchableTextModule } from "../stretchable-text/stretchable-text.module";
import { CustomerDemandComponent } from "./demand.component";

@NgModule({
  declarations: [
    CustomerDemandComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    SvgIconModule,
    NgxTypedJsModule,
    LinksModule,
    RouterModule,
    StretchableTextModule,
  ],
  exports:[CustomerDemandComponent],
  providers: [],
  bootstrap: [],
})
export class CustomerDemandModule {}
